import React, { Component } from "react";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { getDateObj, formatAMPM, getCustomDate, isInsurerAdmin } from "../../../services/insurance/common"
import { STATUS_CODE_MAP, USER } from "../../../constants/provider/constant";
import { getFileDownload } from "../../../services/insurance/common";
class ShowCorresponseProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: USER.user,
      statusHistory: this.props.statusHistory,
      apptHistory: this.props.apptHistory,
      isShowUploadedReport: true,
      doctorQualification: this.props.apptHistory && this.props.apptHistory.additionals.additionals.doctorQualification ? this.props.apptHistory.additionals.additionals.doctorQualification : 'Not selected',
    }
  }

  toShowUploadedReport() {
    let isShowUploadedReport = this.state.isShowUploadedReport;
    let isCommunication = true;
    if (this.state.user && this.state.user.entityType === 'Insurer') {
      isCommunication = false;
    }
    let isInsurerReportStatus = [];
    isInsurerReportStatus = this.state.statusHistory.filter(el => el.statusId === STATUS_CODE_MAP["QCApproved"]);
    console.log("isInsurerReportStatus 48::", isInsurerReportStatus)
    if (isInsurerReportStatus.length === 0) {
      isInsurerReportStatus = this.state.statusHistory.filter(el => el.statusId === STATUS_CODE_MAP["TU Scheduled"])
      console.log("isInsurerReportStatus 122::", isInsurerReportStatus)
    }
    isCommunication ? isShowUploadedReport = true : isInsurerReportStatus.length > 0 ? isShowUploadedReport = true : isShowUploadedReport = false;
    console.log("isInsurerReportStatus::", isShowUploadedReport)
    this.setState({
      isShowUploadedReport: isShowUploadedReport
    })
    console.log("isShowUploadedReport", isShowUploadedReport)
  }

  getDownloadLinks(collection, property) {
    var res = [];
    var downloadUrl = "https://procheck-node.medibuddy.in/file/download/"
    if (property)
      res.push({
        link: downloadUrl + property,
        name: collection[property]
      });
    else {
     res= Object.keys(collection).map(ele => ({
          link: downloadUrl + ele,
          name: collection[ele]
        })
      )
    }
    return res;
  }


  getDownloadedLinks() {
    this.state.statusHistory.map(e => {
      // if(e.attachments){
        e.attachedFiles= e.attachments ?? {};
      // }
      if (e.attachedFiles?.bills && Object.keys(e.attachedFiles?.bills).length > 0) {
        e.attachedFiles.attachmentsBill = [];
        e.attachedFiles.attachmentsReports = [];
        e.attachedFiles.correspondenceReports = [];
        if (typeof e.attachedFiles.bills == "object") {
          if (Object.keys(e.attachedFiles.bills).length > 1) {
            e.attachedFiles.attachmentsBill = this.getDownloadLinks(e.attachedFiles.bills);
          } else {
            e.attachedFiles.attachmentsBill = this.getDownloadLinks(e.attachedFiles.bills, Object.keys(e.attachedFiles.bills)[0]);
          }
        }
      }
      if (e.attachedFiles?.reports && Object.keys(e.attachedFiles?.reports).length > 0) {
        if (typeof e.attachedFiles.reports == "object") {
          if (Object.keys(e.attachedFiles.reports).length > 1) {
            e.attachedFiles.attachmentsReports = this.getDownloadLinks(e.attachedFiles.reports);
          }
          else {
            e.attachedFiles.attachmentsReports = this.getDownloadLinks(e.attachedFiles.reports, Object.keys(e.attachedFiles.reports)[0]);
          }
        }
      }
      if (e.correspondences && e.correspondences.length > 0) {
        e.correspondences.map((v, i) => {
          if (typeof e.correspondences[i] == "object") {
            if (v.attachFiles.correspondencereports && Object.keys(v.attachFiles.correspondencereports).length > 0) {
              e.attachedFiles.correspondenceReports = this.getDownloadLinks(v.attachFiles.correspondencereports);
            }
          }
          return null;
        })
      }
      return null
    })

  }

  componentDidMount() {
    this.toShowUploadedReport();
    this.getDownloadedLinks();
  }

  eachCorrespondence() {
    return (
      <Timeline position="alternate">
        {
          this.state.statusHistory.map((elem, index) => (
            <TimelineItem key={index}>
              <TimelineOppositeContent color="text.secondary">
                {getCustomDate(getDateObj(elem.date))}, {formatAMPM(getDateObj(elem.date))}
                <div className="text-sm text-red-600 font-semibold">
                  {elem.correspondences.length === 0 ? " No correspondence recorded for this status " : ''}
                </div>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot color={index === 0? "success" : "primary"}/>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <div className={(index%2 === 1)  ? "corr-card-design-2 rounded-lg shadow-lg  px-6 py-4" : "corr-card-design-1 rounded-lg shadow-lg  px-6 py-4"}>
                  <div className="mb-3">
                    <h3 className="font-bold text-gray-800 text-xl">
                      {elem.status}
                    </h3>
                    <div className="text-sm">{elem.requestCreatedBy}</div>
                  </div>

                  {elem.remarks ?
                    <div className="text-sm">
                      <span> Notes : </span>
                      <span>
                        {elem.remarks}
                      </span>
                    </div>
                    : ''}
                  {elem.statusId === STATUS_CODE_MAP["QCApproved"] ?
                    <div className="text-sm">
                      <span> Doctor qualification : </span>
                      <span>
                        {this.state.doctorQualification}
                      </span>
                    </div>
                    : ''}

                  { isInsurerAdmin() && (elem.statusId === STATUS_CODE_MAP["Info submitted"] || elem.statusId === STATUS_CODE_MAP["TU Completed"] || elem.statusId === STATUS_CODE_MAP["TU Scheduled"]) && elem.attachedFiles && elem.attachedFiles.attachmentsBill && elem.attachedFiles.attachmentsBill.length > 0 ?
                    <div className="text-sm">
                      <span> Uploaded bills : </span>
                      <div>
                        <ul className="pl-16">
                          {elem.attachedFiles.attachmentsBill.map((billData, index) => (
                            <li className="list-none" key={index}>
                              <a className="text-blue-600"  onClick={()=>{getFileDownload(billData.name, billData.link)}}  style={{cursor:'pointer'}} >{billData.name}</a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    : ''}

                            
                  { isInsurerAdmin() && this.state.isShowUploadedReport && elem.attachedFiles && elem.attachedFiles.attachmentsReports && elem.attachedFiles.attachmentsReports.length > 0 ?
                    <div className="text-sm">
                      <span> Uploaded reports : </span>
                      <div>
                        <ul className="pl-16">
                          {elem.attachedFiles.attachmentsReports.map((billData, index) => (
                            <li className="list-none" key={index}>
                              <a className="text-blue-600"  onClick={()=>{getFileDownload(billData.name, billData.link)}}  style={{cursor:'pointer'}} >{billData.name}</a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    : ''}

                  {
                    elem.correspondences.length > 0 ? elem.correspondences.map((corres,index) => (
                      <div key={index} className={"py-5 " + (index === elem.correspondences.length-1 ? '' : 'border-b-2 border-gray-400')}>
                        <div>
                          <span className="font-semibold"> {corres.correspondenceTypeValue} </span> to
                          <span className="font-semibold"> {corres.callTypeValue} </span> |
                          <span className="font-semibold"> {corres.callStatusValue} </span> |
                          <span className="text-xs">  {getCustomDate(getDateObj(corres.createdOn))}, {formatAMPM(getDateObj(corres.createdOn))} </span>
                        </div>
                        <div className="text-sm">
                          {/* <span>Remarks:</span> { corres.comment }<br /> */}
                          { elem.attachedFiles && elem.attachedFiles.correspondenceReports &&  elem.attachedFiles.correspondenceReports.length>0 ? 
                          <div>Documents:</div> : ''}
                          <ul>
                            {elem.attachedFiles && elem.attachedFiles.correspondenceReports &&  elem.attachedFiles.correspondenceReports.length>0 ? 
                            elem.attachedFiles.correspondenceReports.map((corrsData, index) => (
                              <li className="list-none" key={index}>
                                <a className="text-blue-600" href={corrsData.link} download>{corrsData.name}</a>
                              </li>
                            )) : ''}
                          </ul>
                        </div>
                      </div>
                    )) : ''
                  }

                </div>
              </TimelineContent>
            </TimelineItem>
          ))
        }
      </Timeline>
    )
  }

  showTimeLine() {
    return (
      <Timeline position="alternate">
        <TimelineItem>
          <TimelineOppositeContent color="text.secondary">
            09:30 am
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot variant="outlined" color="primary" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>Eat</TimelineContent>
        </TimelineItem>


        <TimelineItem>
          <TimelineOppositeContent color="text.secondary">
            10:00 am
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>Code</TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineOppositeContent color="text.secondary">
            12:00 am
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>Sleep</TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineOppositeContent color="text.secondary">
            9:00 am
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>Repeat</TimelineContent>
        </TimelineItem>
      </Timeline>
    )
  }

  render() {
    return (
      <div>
        {this.eachCorrespondence()}
      </div>
    );
  }

}

export default ShowCorresponseProvider;